import { Link } from "react-router-dom";

interface QuickItem {
  label: string;
  genre: string;
  icon: string;
  desc: string;
}

interface CategoryQuickEntryProps {
  title: string;
  subtitle: string;
  basePath: string;
  items: QuickItem[];
}

export default function CategoryQuickEntry({
  title,
  subtitle,
  basePath,
  items,
}: CategoryQuickEntryProps) {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-8 md:px-6 md:py-10">
      <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            <span className="h-6 w-1.5 rounded-full bg-primary-500" />
            {title}
          </h2>
          <p className="mt-2 text-sm text-foreground-600">{subtitle}</p>
        </div>
        <Link
          to={basePath}
          className="flex items-center gap-1 text-sm font-medium whitespace-nowrap text-primary-600 transition-colors hover:text-primary-800"
        >
          查看全部
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
        {items.map((item) => (
          <Link
            key={item.label}
            to={`${basePath}?genre=${encodeURIComponent(item.genre)}`}
            className="group flex flex-col items-center rounded-lg border border-background-200/70 bg-background-50 px-3 py-5 text-center transition-all duration-300 hover:border-accent-300 hover:bg-accent-50"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-accent-100 text-accent-700 transition-colors group-hover:bg-accent-500 group-hover:text-background-50">
              <i className={`${item.icon} text-2xl`} />
            </span>
            <span className="mt-3 font-heading text-sm font-semibold text-foreground-950">
              {item.label}
            </span>
            <span className="mt-1 text-xs text-foreground-500">{item.desc}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}